<template>
  <div id="app" class="yk-page">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <!-- PAGE HEADER -->
      <div class="yk-topbar">
        <div>
          <div class="yk-topbar-eyebrow">COPER / RAPORLAR</div>
          <h1>Yeni Kotasyon Formu</h1>
          <p>Satış, maliyet, kârlılık ve fatura detaylarını tek ekranda görüntüleyin.</p>
        </div>

        <div class="yk-topbar-badge" v-if="kotasyonData">
          <span>PNR</span>
          <strong>{{ kotasyonData.PNR_No }}</strong>
        </div>
      </div>

      <v-container fluid class="yk-container">
        <!-- FILTER CARD -->
        <v-card class="yk-card yk-filter-card" flat>
          <div class="yk-filter-title">
            <div class="yk-section-icon">
              <v-icon>tune</v-icon>
            </div>
            <div>
              <strong>Rapor Parametreleri</strong>
              <small>Görüntülemek istediğiniz rezervasyonu ve para birimini seçin.</small>
            </div>
          </div>

          <v-layout row wrap align-center class="yk-filter-grid">
            <v-flex xs12 sm6 md2 class="yk-field">
              <v-select
                label="Arama Tipi"
                :items="itemstip"
                item-text="text"
                item-value="value"
                v-model="Kotasyon.Tip"
                hide-details
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md2 class="yk-field" v-if="Kotasyon.Tip == 1">
              <pnrbul v-model="Kotasyon.Id"></pnrbul>
            </v-flex>

            <v-flex xs12 sm6 md2 class="yk-field" v-if="Kotasyon.Tip == 2">
              <takipno v-model="Kotasyon.Id" hide-details></takipno>
            </v-flex>

            <v-flex xs12 sm6 md2 class="yk-field">
              <v-select
                hide-details
                :items="doviztipi"
                v-model="Kotasyon.ParaBirimi"
                :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                item-text="Title"
                item-value="DovizKod"
                label="Para Birimi"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md2 class="yk-check">
              <v-checkbox
                v-model="Kotasyon.FaturaTurariKdvHaric"
                label="KDV Hariç"
                color="info"
                hide-details
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm6 md2 class="yk-check">
              <v-checkbox
                v-model="Toplam0Gosterme"
                label="0 Toplamları Gizle"
                color="info"
                hide-details
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm6 md2 class="yk-check">
              <v-checkbox
                v-model="resarvationNoteView"
                label="Rezervasyon Notları"
                color="info"
                hide-details
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 md2 class="yk-search-wrap">
              <v-btn
                class="yk-search-btn"
                color="info"
                dark
                :loading="progress"
                @click="getList"
                block
              >
                <v-icon left>search</v-icon>
                Raporu Getir
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <!-- REPORT -->
        <div v-if="faturagoster && kotasyonData">
          <!-- SUMMARY STRIP -->
          <v-layout row wrap class="yk-stat-grid">
            <v-flex xs12 sm6 md3 class="yk-stat-cell">
              <div class="yk-stat-card yk-stat-blue">
                <div class="yk-stat-icon"><v-icon>trending_up</v-icon></div>
                <div>
                  <small>Toplam Satış</small>
                  <strong>{{ kotasyonData.Toplamlar.Satis | moneyformat }} {{ getDovizAdi() }}</strong>
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 md3 class="yk-stat-cell">
              <div class="yk-stat-card yk-stat-red">
                <div class="yk-stat-icon"><v-icon>trending_down</v-icon></div>
                <div>
                  <small>Toplam Maliyet</small>
                  <strong>{{ kotasyonData.Toplamlar.Alis | moneyformat }} {{ getDovizAdi() }}</strong>
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 md3 class="yk-stat-cell">
              <div class="yk-stat-card yk-stat-green">
                <div class="yk-stat-icon"><v-icon>account_balance_wallet</v-icon></div>
                <div>
                  <small>Net Kâr</small>
                  <strong>{{ kotasyonData.Toplamlar.Kar | moneyformat }} {{ getDovizAdi() }}</strong>
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 md3 class="yk-stat-cell">
              <div class="yk-stat-card yk-stat-purple">
                <div class="yk-stat-icon"><v-icon>pie_chart</v-icon></div>
                <div>
                  <small>Tahmini Kârlılık</small>
                  <strong>% {{ kotasyonData.Toplamlar.TahminiKarlilikOrani | moneyformat }}</strong>
                </div>
              </div>
            </v-flex>
          </v-layout>

          <v-layout row wrap class="yk-main-layout">
            <!-- MAIN REPORT -->
            <v-flex xs12 lg10 class="yk-report-col">
              <div id="printJS-form">
                <!-- INFORMATION HERO -->
                <section class="yk-report-card yk-info-card">
                  <div class="yk-report-heading">
                    <div>
                      <span class="yk-kicker">KOTASYON ÖZETİ</span>
                      <h2>Rezervasyon Bilgileri</h2>
                    </div>
                    <div class="yk-date-badge">
                      <v-icon small>event</v-icon>
                      {{ getDateNow() | dateformat }}
                    </div>
                  </div>

                  <div class="yk-info-grid">
                    <div class="yk-info-item">
                      <span>PNR No</span>
                      <strong>{{ kotasyonData.PNR_No }}</strong>
                    </div>
                    <div class="yk-info-item">
                      <span>Takip No</span>
                      <strong>{{ kotasyonData.TakipNo || '-' }}</strong>
                    </div>
                    <div class="yk-info-item">
                      <span>Kayıt Tarihi</span>
                      <strong>{{ kotasyonData.KayitTarihi | dateformat }}</strong>
                    </div>
                    <div class="yk-info-item">
                      <span>Pozisyon No</span>
                      <strong>{{ kotasyonData.PozisyonNo || '-' }}</strong>
                    </div>
                    <div class="yk-info-item yk-info-wide">
                      <span>Müşteri</span>
                      <strong v-if="kotasyonData.Musteri">
                        {{ kotasyonData.Musteri.kod }} - {{ kotasyonData.Musteri.isim }}
                      </strong>
                      <strong v-else>-</strong>
                    </div>
                    <div class="yk-info-item">
                      <span>Karşı Rez. Kod</span>
                      <strong>{{ kotasyonData.KarsiRezKod || '-' }}</strong>
                    </div>
                    <div class="yk-info-item">
                      <span>Tur Kodu</span>
                      <strong>{{ kotasyonData.TurKodu || '-' }}</strong>
                    </div>
                    <div class="yk-info-item">
                      <span>Rezervasyon Yapan</span>
                      <strong>{{ kotasyonData.RezYapan || '-' }}</strong>
                    </div>
                    <div class="yk-info-item">
                      <span>Rezervasyon Veren</span>
                      <strong>{{ kotasyonData.RezVeren || '-' }}</strong>
                    </div>
                    <div class="yk-info-item">
                      <span>Referans</span>
                      <strong>{{ kotasyonData.Referans || '-' }}</strong>
                    </div>
                    <div class="yk-info-item">
                      <span>Masraf Yeri</span>
                      <strong v-if="kotasyonData.MasrafMerkezi">
                        {{ kotasyonData.MasrafMerkezi.kod || kotasyonData.MasrafMerkezi.Kod || '-' }}
                        <template v-if="kotasyonData.MasrafMerkezi.isim"> - {{ kotasyonData.MasrafMerkezi.isim }}</template>
                      </strong>
                      <strong v-else>-</strong>
                    </div>
                  </div>
                </section>

                <!-- SALES -->
                <section class="yk-report-card">
                  <div class="yk-section-heading yk-section-sales">
                    <div class="yk-section-title">
                      <span class="yk-section-dot"></span>
                      <div>
                        <h3>Satış Fiyatları</h3>
                        <small>Müşteriye yansıtılan hizmet ve satış tutarları</small>
                      </div>
                    </div>
                    <div class="yk-section-total">
                      <span>Satış Toplamı</span>
                      <strong>{{ kotasyonData.Toplamlar.Satis | moneyformat }} {{ getDovizAdi() }}</strong>
                    </div>
                  </div>

                  <div class="yk-table-scroll">
                    <table class="yk-table">
                      <thead>
                        <tr>
                          <th class="yk-desc">Açıklama</th>
                          <th>Dönem</th>
                          <th>Pax</th>
                          <th>Gece</th>
                          <th>Oda / Adet</th>
                          <th>Birim Fiyat</th>
                          <th>PB</th>
                          <th>Kur</th>
                          <th>Döviz Tutar</th>
                          <th>{{ getDovizAdi() }} Tutar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in kotasyonData.Satis" :key="'s-' + item.IslemRef">
                          <td class="yk-desc-cell">{{ item.Aciklama }}</td>
                          <td class="yk-nowrap">{{ item.Donem1 | dateformat }} – {{ item.Donem2 | dateformat }}</td>
                          <td class="yk-center">{{ item.Pax }}</td>
                          <td class="yk-center">{{ item.Gece }}</td>
                          <td class="yk-center">{{ item.Oda }}</td>
                          <td class="yk-money">{{ item.BirimFiyat | moneyformat }}</td>
                          <td class="yk-center"><span class="yk-currency-pill">{{ item.ParaBirimi }}</span></td>
                          <td class="yk-money">{{ item.Kur | currencyformat }}</td>
                          <td class="yk-money">{{ item.DovizTutar | moneyformat }}</td>
                          <td class="yk-money yk-strong">{{ item.Tutar | moneyformat }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <!-- COST -->
                <section class="yk-report-card">
                  <div class="yk-section-heading yk-section-cost">
                    <div class="yk-section-title">
                      <span class="yk-section-dot"></span>
                      <div>
                        <h3>Maliyetler</h3>
                        <small>Satıcı ve hizmet bazında alış / maliyet tutarları</small>
                      </div>
                    </div>
                    <div class="yk-section-total">
                      <span>Maliyet Toplamı</span>
                      <strong>{{ kotasyonData.Toplamlar.Alis | moneyformat }} {{ getDovizAdi() }}</strong>
                    </div>
                  </div>

                  <div class="yk-table-scroll">
                    <table class="yk-table">
                      <thead>
                        <tr>
                          <th class="yk-desc">Açıklama</th>
                          <th>Dönem</th>
                          <th>Pax</th>
                          <th>Gece / Gün</th>
                          <th>Oda / Adet</th>
                          <th>Birim Fiyat</th>
                          <th>PB</th>
                          <th>Kur</th>
                          <th>Döviz Tutar</th>
                          <th>{{ getDovizAdi() }} Tutar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in kotasyonData.Alis" :key="'a-' + item.IslemRef">
                          <td class="yk-desc-cell">{{ item.Aciklama }}</td>
                          <td class="yk-nowrap">{{ item.Donem1 | dateformat }} – {{ item.Donem2 | dateformat }}</td>
                          <td class="yk-center">{{ item.Pax }}</td>
                          <td class="yk-center">{{ item.Gece }}</td>
                          <td class="yk-center">{{ item.Oda }}</td>
                          <td class="yk-money">{{ item.BirimFiyat | moneyformat }}</td>
                          <td class="yk-center"><span class="yk-currency-pill">{{ item.ParaBirimi }}</span></td>
                          <td class="yk-money">{{ item.Kur | currencyformat }}</td>
                          <td class="yk-money">{{ item.DovizTutar | moneyformat }}</td>
                          <td class="yk-money yk-strong">{{ item.Tutar | moneyformat }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <!-- COMMISSION -->
                <section
                  class="yk-report-card"
                  v-if="!Toplam0Gosterme || (kotasyonData.Toplamlar && kotasyonData.Toplamlar.Komisyon > 0)"
                >
                  <div class="yk-section-heading yk-section-commission">
                    <div class="yk-section-title">
                      <span class="yk-section-dot"></span>
                      <div>
                        <h3>Komisyonlar</h3>
                        <small>Rezervasyona bağlı komisyon hareketleri</small>
                      </div>
                    </div>
                    <div class="yk-section-total">
                      <span>Komisyon</span>
                      <strong>{{ kotasyonData.Toplamlar.Komisyon | moneyformat }} {{ getDovizAdi() }}</strong>
                    </div>
                  </div>

                  <div class="yk-table-scroll">
                    <table class="yk-table">
                      <thead>
                        <tr>
                          <th class="yk-desc">Açıklama</th>
                          <th>PB</th>
                          <th>Kur</th>
                          <th>Döviz Tutar</th>
                          <th>{{ getDovizAdi() }} Tutar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in kotasyonData.Komisyon" :key="'k-' + item.IslemRef">
                          <td class="yk-desc-cell">{{ item.Aciklama }}</td>
                          <td class="yk-center"><span class="yk-currency-pill">{{ item.ParaBirimi }}</span></td>
                          <td class="yk-money">{{ item.Kur | currencyformat }}</td>
                          <td class="yk-money">{{ item.DovizTutar | moneyformat }}</td>
                          <td class="yk-money yk-strong">{{ item.Tutar | moneyformat }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <!-- PAYMENTS -->
                <section
                  class="yk-report-card"
                  v-if="!Toplam0Gosterme || (kotasyonData.Toplamlar && kotasyonData.Toplamlar.SaticiOdemesi > 0)"
                >
                  <div class="yk-section-heading yk-section-payment">
                    <div class="yk-section-title">
                      <span class="yk-section-dot"></span>
                      <div>
                        <h3>Satıcılara Yapılan Ödemeler</h3>
                        <small>Satıcı bazında gerçekleşen ödeme hareketleri</small>
                      </div>
                    </div>
                    <div class="yk-section-total">
                      <span>Toplam Ödeme</span>
                      <strong>{{ kotasyonData.Toplamlar.SaticiOdemesi | moneyformat }} {{ getDovizAdi() }}</strong>
                    </div>
                  </div>

                  <div class="yk-table-scroll">
                    <table class="yk-table">
                      <thead>
                        <tr>
                          <th class="yk-desc">Firma / Hesap / Kart</th>
                          <th>Tarih</th>
                          <th>Tip</th>
                          <th>PB</th>
                          <th>Kur</th>
                          <th>Döviz Tutar</th>
                          <th>{{ getDovizAdi() }} Tutar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in kotasyonData.SaticiOdemeleri" :key="'so-' + item.SaticiKod + '-' + item.Tarih">
                          <td class="yk-desc-cell">{{ item.SaticiKod }} / {{ item.CariUnvan }} / {{ item.KartNo }}</td>
                          <td class="yk-nowrap">{{ item.Tarih | dateformat }}</td>
                          <td class="yk-center">{{ item.EvrakTipi }}</td>
                          <td class="yk-center"><span class="yk-currency-pill">{{ item.ParaBirimi }}</span></td>
                          <td class="yk-money">{{ item.Kur | currencyformat }}</td>
                          <td class="yk-money">{{ item.DovizTutar | moneyformat }}</td>
                          <td class="yk-money yk-strong">{{ item.Tutar | moneyformat }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <!-- COLLECTIONS -->
                <section
                  class="yk-report-card"
                  v-if="!Toplam0Gosterme || (kotasyonData.Toplamlar && kotasyonData.Toplamlar.Tahsilat > 0)"
                >
                  <div class="yk-section-heading yk-section-collection">
                    <div class="yk-section-title">
                      <span class="yk-section-dot"></span>
                      <div>
                        <h3>Tahsilatlar</h3>
                        <small>Müşteri bazında gerçekleşen tahsilat hareketleri</small>
                      </div>
                    </div>
                    <div class="yk-section-total">
                      <span>Toplam Tahsilat</span>
                      <strong>{{ kotasyonData.Toplamlar.Tahsilat | moneyformat }} {{ getDovizAdi() }}</strong>
                    </div>
                  </div>

                  <div class="yk-table-scroll">
                    <table class="yk-table">
                      <thead>
                        <tr>
                          <th class="yk-desc">Firma</th>
                          <th>Tarih</th>
                          <th>Tip</th>
                          <th>PB</th>
                          <th>Kur</th>
                          <th>Döviz Tutar</th>
                          <th>{{ getDovizAdi() }} Tutar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in kotasyonData.Tahsilatlar" :key="'t-' + item.CariKod + '-' + item.Tarih">
                          <td class="yk-desc-cell">{{ item.CariKod }}</td>
                          <td class="yk-nowrap">{{ item.Tarih | dateformat }}</td>
                          <td class="yk-center">{{ item.EvrakTipi }}</td>
                          <td class="yk-center"><span class="yk-currency-pill">{{ item.ParaBirimi }}</span></td>
                          <td class="yk-money">{{ item.Kur | currencyformat }}</td>
                          <td class="yk-money">{{ item.DovizTutar | moneyformat }}</td>
                          <td class="yk-money yk-strong">{{ item.Tutar | moneyformat }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <!-- PROFITABILITY -->
                <section class="yk-report-card yk-profit-card">
                  <div class="yk-profit-left">
                    <span class="yk-kicker">KÂRLILIK ANALİZİ</span>
                    <h3>Rezervasyon Performansı</h3>

                    <div class="yk-profit-rates">
                      <div class="yk-rate-box">
                        <span>Tahmini Kârlılık</span>
                        <strong>% {{ kotasyonData.Toplamlar.TahminiKarlilikOrani | moneyformat }}</strong>
                      </div>

                      <div class="yk-rate-box">
                        <span>Gerçekleşen Kârlılık</span>
                        <strong>% {{ kotasyonData.Toplamlar.GerceklesenKarlilikOrani | moneyformat }}</strong>
                      </div>
                    </div>
                  </div>

                  <div class="yk-profit-summary">
                    <div><span>Toplam Satış</span><strong>{{ kotasyonData.Toplamlar.Satis | moneyformat }} {{ getDovizAdi() }}</strong></div>
                    <div><span>Toplam İskonto</span><strong>{{ kotasyonData.Toplamlar.Iskonto | moneyformat }} {{ getDovizAdi() }}</strong></div>
                    <div><span>Toplam Maliyet</span><strong>{{ kotasyonData.Toplamlar.Alis | moneyformat }} {{ getDovizAdi() }}</strong></div>
                    <div><span>Toplam Komisyon</span><strong>{{ kotasyonData.Toplamlar.Komisyon | moneyformat }} {{ getDovizAdi() }}</strong></div>
                    <div><span>Acente Komisyon</span><strong>{{ kotasyonData.Toplamlar.AcenteKomisyon | moneyformat }} {{ getDovizAdi() }}</strong></div>
                    <div class="yk-profit-final"><span>Net Kâr</span><strong>{{ kotasyonData.Toplamlar.Kar | moneyformat }} {{ getDovizAdi() }}</strong></div>
                  </div>
                </section>

                <!-- NOTES -->
                <section v-if="resarvationNoteView && kotasyonData.Notlar" class="yk-report-card yk-note-card">
                  <div class="yk-note-icon"><v-icon>notes</v-icon></div>
                  <div>
                    <span class="yk-kicker">REZERVASYON NOTLARI</span>
                    <p>{{ kotasyonData.Notlar }}</p>
                  </div>
                </section>

                <!-- INVOICES -->
                <section class="yk-report-card">
                  <div class="yk-section-heading yk-section-invoice">
                    <div class="yk-section-title">
                      <span class="yk-section-dot"></span>
                      <div>
                        <h3>
                          <span v-if="KdvHaric">KDV Hariç Fatura Bilgileri</span>
                          <span v-else>KDV'li Fatura Bilgileri</span>
                        </h3>
                        <small>Rezervasyona bağlı düzenlenen faturalar ve toplamları</small>
                      </div>
                    </div>
                  </div>

                  <div class="yk-table-scroll">
                    <table class="yk-table">
                      <thead>
                        <tr>
                          <th>Fatura Tipi</th>
                          <th>Fatura No</th>
                          <th>Fatura Tarihi</th>
                          <th class="yk-desc">Cari Ünvan</th>
                          <th>Gelen Fatura</th>
                          <th>Satış Fat.</th>
                          <th>Kom. Fat.</th>
                          <th>İade Fatura</th>
                          <th>Satış İa. Fat.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in kotasyonData.Faturalar" :key="'f-' + item.Seri + '-' + item.No">
                          <td>{{ item.TipAciklama }}</td>
                          <td class="yk-center">{{ item.No }}</td>
                          <td class="yk-nowrap">{{ item.Tarih | dateformat }}</td>
                          <td class="yk-desc-cell">{{ item.CariUnvan }}</td>
                          <td class="yk-money">{{ faturaTipTutar(item, 1) }}</td>
                          <td class="yk-money">{{ faturaTipTutar(item, 2) }}</td>
                          <td class="yk-money">{{ faturaTipTutar(item, 3) }}</td>
                          <td class="yk-money">{{ faturaTipTutar(item, 4) }}</td>
                          <td class="yk-money">{{ faturaTipTutar(item, 5) }}</td>
                        </tr>

                        <tr v-if="kotasyonData.FaturaToplam" class="yk-total-row">
                          <td colspan="4">Fatura Toplamları ({{ getDovizAdi() }})</td>
                          <td class="yk-money">{{ kotasyonData.FaturaToplam.Gelen | moneyformat }}</td>
                          <td class="yk-money">{{ kotasyonData.FaturaToplam.Satis | moneyformat }}</td>
                          <td class="yk-money">{{ kotasyonData.FaturaToplam.Komisyon | moneyformat }}</td>
                          <td class="yk-money">{{ kotasyonData.FaturaToplam.Iade | moneyformat }}</td>
                          <td class="yk-money">{{ kotasyonData.FaturaToplam.SatisIade | moneyformat }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="yk-invoice-profit" v-if="kotasyonData.FaturaToplam">
                    <span>Fatura Kârı</span>
                    <strong>{{ kotasyonData.FaturaToplam.Kar | moneyformat }} {{ getDovizAdi() }}</strong>
                  </div>
                </section>
              </div>
            </v-flex>

            <!-- STICKY ACTIONS -->
            <v-flex xs12 lg2 class="yk-actions-col">
              <div class="yk-actions-card">
                <span class="yk-kicker">İŞLEMLER</span>
                <h3>Raporu Dışa Aktar</h3>
                <p>Formu yazdırabilir veya dosya olarak indirebilirsiniz.</p>

                <v-btn class="yk-action-btn" block color="info" dark @click="yazdir">
                  <v-icon left>print</v-icon>
                  Yazdır
                </v-btn>

                <v-btn
                  class="yk-action-btn"
                  block
                  color="red"
                  dark
                  :loading="pdfLoading"
                  @click="pdfIndir"
                >
                  <v-icon left>picture_as_pdf</v-icon>
                  PDF İndir
                </v-btn>

                <v-btn
                  class="yk-action-btn"
                  block
                  color="green"
                  dark
                  :loading="excelLoading"
                  @click="excelIndir"
                >
                  <v-icon left>table_chart</v-icon>
                  Excel İndir
                </v-btn>

                <div class="yk-action-info">
                  <v-icon small>verified_user</v-icon>
                  <span>Veriler mevcut rezervasyondan anlık olarak hazırlanır.</span>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import auth from "../../../../../api/auth";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import tool from "../../../coper/tools";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import takipno from "@/components/app/coper/component/takipno.vue";

export default {
  data() {
    return {
      UlkeID: 1,
      Toplam0Gosterme: true,
      resarvationNoteView: true,
      dovizBirimi: "TL",
      doviztipi: [],
      kotasyonData: null,
      faturagoster: false,
      progress: false,
      pdfLoading: false,
      excelLoading: false,
      KdvHaric: false,
      text1: "",
      snackbar: false,

      Kotasyon: {
        Tip: 1,
        Id: null,
        ParaBirimi: "TL",
        FaturaTurariKdvHaric: false,
        MusteriOdemelilerHaric: false,
        BirimFiyatOdaFiyati: false
      },

      itemstip: [
        { text: "PNR", value: 1 },
        { text: "Takip No", value: 2 }
      ]
    };
  },

  mounted() {
    this.UlkeID = window.localStorage.getItem("UlkeID") || 1;

    if (this.$route.query.islem == "get") {
      this.Kotasyon.Tip = Number(this.$route.query.Tip || 1);
      this.Kotasyon.Id = this.$route.query.PNR_No || this.$route.query.Id;
    }

    this.dovizGetir();
  },

  filters: {
    dateformat(t) {
      return t ? helpers.dateformat(t) : "";
    },

    currencyformat(t) {
      return helpers.currencyformat(t || 0);
    },

    moneyformat(m) {
      return helpers.moneyformat(m || 0);
    }
  },

  components: {
    yetkidialog,
    hatadialog,
    pnrbul,
    takipno
  },

  watch: {
    "Kotasyon.Tip": function () {
      if (this.$route.query.islem != "get") {
        this.Kotasyon.Id = null;
      }
    }
  },

  methods: {
    dovizGetir() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials") || "{}");
      var params = {
        CompanyCode: credentials.SirketKodu
      };

      this.$http.post(
        auth.API_URL + "api/currency/List",
        params,
        {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }
      ).then(
        response => {
          this.doviztipi = response.body || [];

          if (!this.doviztipi.some(x => x.DovizKod == "TL")) {
            this.doviztipi.push({
              DovizKod: "TL",
              DovizAdi: "TÜRK LİRASI",
              Title: "TL - TÜRK LİRASI"
            });
          }

          this.applyDefaultCurrencyFromStorage();

          if (this.$route.query.islem == "get" && this.Kotasyon.Id) {
            this.getList();
          }
        },
        () => {
          this.doviztipi = [{
            DovizKod: "TL",
            DovizAdi: "TÜRK LİRASI",
            Title: "TL - TÜRK LİRASI"
          }];

          this.Kotasyon.ParaBirimi = "TL";

          if (this.$route.query.islem == "get" && this.Kotasyon.Id) {
            this.getList();
          }
        }
      );
    },

    applyDefaultCurrencyFromStorage() {
      var defaultCur = null;

      try {
        var rawResp = window.localStorage.getItem("response");
        if (rawResp) {
          var parsed = JSON.parse(rawResp);
          if (parsed && parsed.ParaBirimi) {
            defaultCur = parsed.ParaBirimi;
          }
        }
      } catch (e) {
        // Eski localStorage verisi bozuksa rapor ekranını durdurma.
      }

      if (!defaultCur) {
        defaultCur = "TL";
      }

      if (this.doviztipi.some(x => x.DovizKod == defaultCur)) {
        this.Kotasyon.ParaBirimi = defaultCur;
      } else {
        this.Kotasyon.ParaBirimi = "TL";
      }
    },

    getList() {
      if (!this.Kotasyon.Id) {
        this.text1 = "PNR / Takip No seçiniz.";
        this.snackbar = true;
        return;
      }

      this.progress = true;
      this.faturagoster = false;
      this.KdvHaric = this.Kotasyon.FaturaTurariKdvHaric;

      var params = JSON.parse(JSON.stringify(this.Kotasyon));

      tool.http_post(this, "YeniKotasyonFormu", params).then(
        response => {
          this.progress = false;

          if (response.body && response.body.Status == true) {
            this.kotasyonData = response.body.data;
            this.dovizBirimi = this.Kotasyon.ParaBirimi;
            this.faturagoster = true;
          } else {
            this.kotasyonData = null;
            this.faturagoster = false;
            this.text1 =
              response.body &&
              response.body.ErrorList &&
              response.body.ErrorList.length > 0
                ? response.body.ErrorList[0]
                : "Yeni Kotasyon Formu hazırlanamadı.";
            this.snackbar = true;
          }
        },
        response => {
          this.progress = false;
          this.faturagoster = false;
          this.HataYonetimi(response, params, "Yeni Kotasyon Formu getirilemedi");
        }
      );
    },

    HataYonetimi(response, request, baslik) {
      if (response && response.status === 500 && this.$refs.hatadialog) {
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable - " + baslik;
        this.snackbar = true;
      }
    },

    getDovizAdi() {
      return this.Kotasyon.ParaBirimi || this.dovizBirimi || "TL";
    },

    getDateNow() {
      return new Date();
    },

    faturaTipTutar(item, tip) {
      if (!item || Number(item.Tip) !== Number(tip)) {
        return "";
      }

      return helpers.moneyformat(item.Tutar || 0);
    },

    yazdir() {
      var element = document.getElementById("printJS-form");
      if (!element) return;

      var mywindow = window.open("", "PRINT", "height=800,width=1200");

      mywindow.document.write("<html><head><title>Yeni Kotasyon Formu</title>");
      mywindow.document.write(
        "<style>" +
        "body{font-family:Arial,Helvetica,sans-serif;font-size:10px;margin:12px;}" +
        "table{width:100%;border-collapse:collapse;table-layout:fixed;}" +
        "td,th{padding:4px;vertical-align:top;word-wrap:break-word;}" +
        ".bordered-table td,.invoice-table td{border:1px solid #222;}" +
        ".section-title{text-align:center;color:#3366ff;font-weight:bold;padding:10px;}" +
        ".column-header td{text-align:center;font-weight:bold;}" +
        ".right{text-align:right;}.center{text-align:center;}.nowrap{white-space:nowrap;}" +
        ".summary-label,.summary-value,.summary-currency,.summary-ratio{border:1px solid #222;}" +
        ".summary-value{text-align:right;}.summary-currency{text-align:center;}" +
        ".section-block,.section-space{margin-top:22px;}" +
        "</style></head><body>"
      );
      mywindow.document.write(element.innerHTML);
      mywindow.document.write("</body></html>");
      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    },

    pdfIndir() {
      this.pdfLoading = true;
      var params = JSON.parse(JSON.stringify(this.Kotasyon));

      tool.api_post_FileDownload(this, "Coper/YeniKotasyonFormuPdf", params).then(
        response => {
          tool.CreateDownloadLink(
            response,
            "YeniKotasyonFormu_" + this.Kotasyon.Id + ".pdf"
          );
          this.pdfLoading = false;
        },
        () => {
          this.pdfLoading = false;
          this.text1 = "Yeni Kotasyon Formu PDF indirilemedi.";
          this.snackbar = true;
        }
      );
    },

    excelIndir() {
      this.excelLoading = true;
      var params = JSON.parse(JSON.stringify(this.Kotasyon));

      tool.api_post_FileDownload(this, "Coper/YeniKotasyonFormuExcel", params).then(
        response => {
          tool.CreateDownloadLink(
            response,
            "YeniKotasyonFormu_" + this.Kotasyon.Id + ".xls"
          );
          this.excelLoading = false;
        },
        () => {
          this.excelLoading = false;
          this.text1 = "Yeni Kotasyon Formu Excel indirilemedi.";
          this.snackbar = true;
        }
      );
    }
  }
};
</script>

<style>
/* =========================================================
   YENİ KOTASYON FORMU - MODERN RAPOR TASARIMI
   ========================================================= */

.yk-page,
.yk-page #inspire {
  background: #f4f7fb !important;
  min-height: 100vh;
  color: #1f2937;
}

.yk-topbar {
  min-height: 112px;
  padding: 24px 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #178eea 0%, #2878d8 100%);
  color: #fff;
  box-shadow: 0 8px 24px rgba(22, 119, 210, .18);
}

.yk-topbar h1 {
  margin: 2px 0 4px;
  font-size: 27px;
  line-height: 34px;
  font-weight: 700;
  letter-spacing: -.4px;
}

.yk-topbar p {
  margin: 0;
  opacity: .86;
  font-size: 13px;
}

.yk-topbar-eyebrow,
.yk-kicker {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
}

.yk-topbar-eyebrow {
  opacity: .78;
}

.yk-topbar-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 130px;
  padding: 11px 15px;
  border: 1px solid rgba(255,255,255,.28);
  border-radius: 12px;
  background: rgba(255,255,255,.11);
  backdrop-filter: blur(8px);
}

.yk-topbar-badge span {
  font-size: 11px;
  opacity: .82;
}

.yk-topbar-badge strong {
  font-size: 18px;
}

.yk-container {
  padding: 22px 28px 36px !important;
  max-width: 1900px;
  margin: 0 auto;
}

.yk-card,
.yk-report-card,
.yk-actions-card {
  background: #fff;
  border: 1px solid #e8edf4;
  border-radius: 14px;
  box-shadow: 0 6px 18px rgba(31, 41, 55, .055);
}

.yk-filter-card {
  padding: 18px 20px 15px;
  margin-bottom: 20px;
}

.yk-filter-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.yk-filter-title strong {
  display: block;
  color: #1f2937;
  font-size: 14px;
}

.yk-filter-title small {
  display: block;
  color: #8a94a6;
  font-size: 11px;
  margin-top: 2px;
}

.yk-section-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eef7ff;
}

.yk-section-icon .v-icon {
  color: #1989df;
  font-size: 20px;
}

.yk-filter-grid {
  margin: -7px;
}

.yk-field,
.yk-check,
.yk-search-wrap {
  padding: 7px;
}

.yk-check {
  display: flex;
  align-items: center;
}

.yk-search-btn {
  min-height: 42px !important;
  margin: 4px 0 0 !important;
  border-radius: 9px;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0 !important;
  box-shadow: 0 5px 13px rgba(33, 150, 243, .2);
}

.yk-stat-grid {
  margin: 0 -7px 14px;
}

.yk-stat-cell {
  padding: 7px;
}

.yk-stat-card {
  min-height: 88px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 17px;
  border-radius: 13px;
  background: #fff;
  border: 1px solid #e8edf4;
  box-shadow: 0 5px 16px rgba(31, 41, 55, .05);
}

.yk-stat-icon {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
}

.yk-stat-icon .v-icon {
  font-size: 21px;
}

.yk-stat-card small {
  display: block;
  color: #8a94a6;
  font-size: 11px;
  margin-bottom: 4px;
}

.yk-stat-card strong {
  display: block;
  color: #202938;
  font-size: 17px;
  line-height: 22px;
}

.yk-stat-blue .yk-stat-icon { background: #eaf5ff; }
.yk-stat-blue .yk-stat-icon .v-icon { color: #188de0; }
.yk-stat-red .yk-stat-icon { background: #fff0f0; }
.yk-stat-red .yk-stat-icon .v-icon { color: #e45858; }
.yk-stat-green .yk-stat-icon { background: #eaf9f1; }
.yk-stat-green .yk-stat-icon .v-icon { color: #28a56b; }
.yk-stat-purple .yk-stat-icon { background: #f3eeff; }
.yk-stat-purple .yk-stat-icon .v-icon { color: #7865d6; }

.yk-main-layout {
  margin: 0 -7px;
}

.yk-report-col,
.yk-actions-col {
  padding: 7px;
}

.yk-report-card {
  margin-bottom: 16px;
  overflow: hidden;
}

.yk-info-card {
  padding: 22px;
}

.yk-report-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 17px;
  margin-bottom: 17px;
  border-bottom: 1px solid #edf1f6;
}

.yk-report-heading .yk-kicker,
.yk-note-card .yk-kicker {
  color: #1d8be0;
}

.yk-report-heading h2 {
  margin: 4px 0 0;
  color: #1c2736;
  font-size: 20px;
  font-weight: 700;
}

.yk-date-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 11px;
  border-radius: 8px;
  background: #f6f8fb;
  color: #64748b;
  font-size: 11px;
  white-space: nowrap;
}

.yk-info-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.yk-info-item {
  min-height: 67px;
  padding: 12px 14px;
  border: 1px solid #edf1f6;
  border-radius: 10px;
  background: #fbfcfe;
}

.yk-info-item span {
  display: block;
  margin-bottom: 6px;
  color: #8a94a6;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .45px;
}

.yk-info-item strong {
  display: block;
  color: #202938;
  font-size: 12px;
  line-height: 17px;
  word-break: break-word;
}

.yk-info-wide {
  grid-column: span 2;
}

.yk-section-heading {
  min-height: 72px;
  padding: 15px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #edf1f6;
}

.yk-section-title {
  display: flex;
  align-items: center;
  gap: 11px;
}

.yk-section-title h3 {
  margin: 0 0 2px;
  color: #202938;
  font-size: 15px;
  font-weight: 700;
}

.yk-section-title small {
  color: #8a94a6;
  font-size: 10px;
}

.yk-section-dot {
  width: 9px;
  height: 34px;
  border-radius: 8px;
  background: #1e8fe5;
}

.yk-section-cost .yk-section-dot { background: #e55b62; }
.yk-section-commission .yk-section-dot { background: #8b68d9; }
.yk-section-payment .yk-section-dot { background: #e4a33d; }
.yk-section-collection .yk-section-dot { background: #27a56b; }
.yk-section-invoice .yk-section-dot { background: #4f78cb; }

.yk-section-total {
  min-width: 175px;
  padding: 8px 12px;
  border-radius: 9px;
  background: #f7f9fc;
  text-align: right;
}

.yk-section-total span {
  display: block;
  color: #8a94a6;
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: .5px;
}

.yk-section-total strong {
  display: block;
  margin-top: 2px;
  color: #202938;
  font-size: 13px;
}

.yk-table-scroll {
  width: 100%;
  overflow-x: auto;
}

.yk-table {
  width: 100%;
  min-width: 1080px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: auto;
  font-size: 11px;
}

.yk-table thead th {
  padding: 11px 10px;
  background: #f8fafc;
  color: #596579;
  border-bottom: 1px solid #e6ebf2;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .4px;
  text-align: center;
  white-space: nowrap;
}

.yk-table thead th:first-child,
.yk-table tbody td:first-child {
  padding-left: 16px;
}

.yk-table thead th:last-child,
.yk-table tbody td:last-child {
  padding-right: 16px;
}

.yk-table tbody td {
  padding: 11px 10px;
  border-bottom: 1px solid #edf1f6;
  color: #364152;
  vertical-align: middle;
  background: #fff;
}

.yk-table tbody tr:nth-child(even) td {
  background: #fbfcfe;
}

.yk-table tbody tr:hover td {
  background: #f3f8fd;
}

.yk-table tbody tr:last-child td {
  border-bottom: 0;
}

.yk-desc {
  min-width: 310px;
  text-align: left !important;
}

.yk-desc-cell {
  min-width: 310px;
  max-width: 470px;
  line-height: 16px;
}

.yk-center {
  text-align: center;
}

.yk-money {
  text-align: right;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.yk-strong {
  color: #1f2937 !important;
  font-weight: 700;
}

.yk-nowrap {
  white-space: nowrap;
  text-align: center;
}

.yk-currency-pill {
  display: inline-block;
  min-width: 34px;
  padding: 3px 7px;
  border-radius: 999px;
  background: #edf4fb;
  color: #3975a7;
  font-size: 9px;
  font-weight: 700;
}

.yk-total-row td {
  background: #f7f9fc !important;
  font-weight: 700;
}

.yk-profit-card {
  display: flex;
  align-items: stretch;
  overflow: hidden;
}

.yk-profit-left {
  width: 36%;
  padding: 23px;
  background: linear-gradient(135deg, #153b63 0%, #1d5d91 100%);
  color: #fff;
}

.yk-profit-left .yk-kicker {
  opacity: .75;
}

.yk-profit-left h3 {
  margin: 5px 0 18px;
  font-size: 18px;
}

.yk-profit-rates {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 9px;
}

.yk-rate-box {
  padding: 12px;
  border: 1px solid rgba(255,255,255,.18);
  border-radius: 9px;
  background: rgba(255,255,255,.08);
}

.yk-rate-box span {
  display: block;
  font-size: 9px;
  opacity: .8;
  margin-bottom: 5px;
}

.yk-rate-box strong {
  display: block;
  font-size: 15px;
}

.yk-profit-summary {
  width: 64%;
  padding: 15px 20px;
}

.yk-profit-summary > div {
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-bottom: 1px dashed #e7ebf1;
}

.yk-profit-summary > div:last-child {
  border-bottom: 0;
}

.yk-profit-summary span {
  color: #7d8798;
  font-size: 11px;
}

.yk-profit-summary strong {
  color: #202938;
  font-size: 12px;
  white-space: nowrap;
}

.yk-profit-final {
  margin: 4px -5px -1px;
  padding: 0 8px;
  border-radius: 8px;
  background: #eef8f3;
}

.yk-profit-final span,
.yk-profit-final strong {
  color: #218a59 !important;
  font-weight: 700;
}

.yk-note-card {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  padding: 18px 20px;
}

.yk-note-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #fff7df;
}

.yk-note-icon .v-icon {
  color: #d59620;
}

.yk-note-card p {
  margin: 6px 0 0;
  color: #596579;
  font-size: 11px;
  line-height: 17px;
  white-space: pre-wrap;
}

.yk-invoice-profit {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 22px;
  padding: 12px 18px;
  background: #f8fafc;
  border-top: 1px solid #edf1f6;
}

.yk-invoice-profit span {
  color: #7d8798;
  font-size: 10px;
}

.yk-invoice-profit strong {
  color: #202938;
  font-size: 13px;
}

.yk-actions-card {
  position: sticky;
  top: 18px;
  padding: 18px;
}

.yk-actions-card .yk-kicker {
  color: #1c8be0;
}

.yk-actions-card h3 {
  margin: 5px 0 5px;
  color: #202938;
  font-size: 16px;
}

.yk-actions-card > p {
  margin: 0 0 16px;
  color: #8a94a6;
  font-size: 10px;
  line-height: 15px;
}

.yk-action-btn {
  min-height: 42px !important;
  margin: 0 0 9px !important;
  border-radius: 9px;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0 !important;
  box-shadow: none !important;
}

.yk-action-info {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 12px;
  padding: 10px;
  border-radius: 8px;
  background: #f7f9fc;
  color: #8a94a6;
  font-size: 9px;
  line-height: 13px;
}

.yk-action-info .v-icon {
  color: #5e9cce;
  margin-top: 1px;
}

/* Vuetify input compact polish */
.yk-filter-card .v-input {
  font-size: 12px;
}

.yk-filter-card .v-label {
  font-size: 12px;
}

/* RESPONSIVE */
@media (max-width: 1263px) {
  .yk-actions-card {
    position: static;
  }

  .yk-info-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .yk-profit-card {
    display: block;
  }

  .yk-profit-left,
  .yk-profit-summary {
    width: 100%;
  }
}

@media (max-width: 700px) {
  .yk-topbar {
    padding: 20px;
  }

  .yk-topbar-badge {
    display: none;
  }

  .yk-container {
    padding: 14px !important;
  }

  .yk-info-grid {
    grid-template-columns: 1fr;
  }

  .yk-info-wide {
    grid-column: span 1;
  }

  .yk-section-heading {
    align-items: flex-start;
    flex-direction: column;
  }

  .yk-section-total {
    width: 100%;
    text-align: left;
  }

  .yk-profit-rates {
    grid-template-columns: 1fr;
  }
}

/* PRINT */
@media print {
  .yk-topbar,
  .yk-filter-card,
  .yk-stat-grid,
  .yk-actions-col {
    display: none !important;
  }

  .yk-page,
  .yk-page #inspire {
    background: #fff !important;
  }

  .yk-container,
  .yk-report-col {
    padding: 0 !important;
  }

  .yk-report-card {
    break-inside: avoid;
    box-shadow: none !important;
    border: 1px solid #d8dee7 !important;
    margin-bottom: 10px;
  }

  .yk-table {
    min-width: 0;
    font-size: 8px;
  }

  .yk-table thead th,
  .yk-table tbody td {
    padding: 6px 5px;
  }

  .yk-desc,
  .yk-desc-cell {
    min-width: 0;
    max-width: none;
  }

  .yk-table-scroll {
    overflow: visible;
  }
}
</style>